import { getWholePartFromCents } from '@npco/component-mp-common'

export const getDollarAmountForDatapoint = (amountInCents: number) =>
  getWholePartFromCents(amountInCents).slice(amountInCents < 0 ? 2 : 1)
